if (typeof SVG_DEFAULT_PATH == "undefined") {
    var SVG_DEFAULT_PATH = '/images/svg-symbols.svg';
}
if (typeof SVG_DEFAULT_PREFIX == "undefined") {
    var SVG_DEFAULT_PREFIX = 'icon';
}
function Svg() {

    this.imagePath = SVG_DEFAULT_PATH;

    this.imageClassPrefix = SVG_DEFAULT_PREFIX;

    this.setImagePath = function(path) {
        if (path) {
            this.imagePath = path;
        }
    }

    this.setImageClassPrefix = function(prefix) {
        if (prefix) {
            this.imageClassPrefix = prefix;
        }
    }

    this.render = function(icon) {
        return '<svg role="img" class="' + this.imageClassPrefix + '-' + this.prepare(icon) + '">' +
                        '<use xlink:href="' + this.imagePath + '#icon-' + this.prepare(icon) + '"></use>' +
                    '</svg>'
    }

    this.prepare = function(icon) {
        return icon.replace('icon-', '');
    }
}
